import { getSvlLockedPdpId } from '../components/PdpComponent';

function GetProductInfo(inputs) {
  const lockedSvlPdpId =
    inputs.sv_family === 'SV-L' ? getSvlLockedPdpId(inputs.machine_type) : null;

  const pdpOptions =
    lockedSvlPdpId !== null
      ? inputs.pdp.filter((pdp) => pdp.id === lockedSvlPdpId && pdp.selected)
      : [{ id: null, description: 'N/A', selected: false }].concat(
          inputs.pdp.filter((pdp) => pdp.selected)
        );

  return {
    PDP: [
      { field: 'name', label: 'Product Name', input: 'str_field' },
      {
        field: 'pdp',
        label: 'PreDefined Product',
        input: 'select',
        options: pdpOptions,
      },
    ],
    Size: [
      { field: 'name', label: 'Product Name', input: 'str_field' },
      {
        field: 'product_shape',
        label: 'Product Shape',
        input: 'select',
        options: ['rectangular', 'round'],
      },
      {
        field: 'length',
        label: 'Length',
        unit: 'mm',
        input: 'float_field',
        shape: 'rectangular',
      },
      {
        field: 'width',
        label: 'Width',
        unit: 'mm',
        input: 'float_field',
        shape: 'rectangular',
      },
      {
        field: 'diameter',
        label: 'Diameter',
        unit: 'mm',
        input: 'float_field',
        shape: 'round',
      },
      {
        field: 'footprint',
        label: 'Footprint',
        unit: 'mm',
        input: 'float_field',
        shape: 'round',
      },
      { field: 'height', label: 'Height', unit: 'mm', input: 'float_field' },
    ],
    Flow: [
      { field: 'name', label: 'Product Name', input: 'str_field' },
      { field: 'weight', label: 'Weight', unit: 'kg', input: 'float_field' },
      {
        field: 'throughput',
        label: 'Throughput',
        unit: 'product/min',
        input: 'float_field',
      },
    ],
  };
}

export default GetProductInfo;
